module.exports = [
  "barnyard",
  "bird",
  "cat",
  "dog",
  "horse",
  "rabbit",
  "scales-fins-other",
  "small-furry"
];
